module.exports = __webpack_public_path__ + "55cfa1d3d12e85396d77c218b736f67f.jpg";